module.exports = __webpack_public_path__ + "img/facebook.b85ea0f8.svg";